/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_TitleInputs */

const en_cap_money_title = /** @type {(inputs: Cap_Money_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads found, researched and followed up.`)
};

const lv_cap_money_title = /** @type {(inputs: Cap_Money_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālie klienti atrasti, izpētīti un uzrunāti.`)
};

/**
* | output |
* | --- |
* | "Leads found, researched and followed up." |
*
* @param {Cap_Money_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_title = /** @type {((inputs?: Cap_Money_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_title(inputs)
	return en_cap_money_title(inputs)
});